import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Skeleton } from 'primeng/skeleton';

/**
 * Loading placeholder for the Cashflow & Financial Snapshot card.
 * Uses PrimeNG `p-skeleton` bones that approximate the complete-state layout
 * (summary + spending mix). See `docs/loading-skeletons.md`.
 */
@Component({
  selector: 'bn-financial-snapshot-skeleton',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Skeleton],
  template: `
    <div class="bn-fs-skeleton" data-testid="financial-snapshot-skeleton" role="status" aria-label="Loading financial snapshot">
      <div class="bn-fs-skeleton__grid">
        <div class="bn-fs-skeleton__col">
          <p-skeleton width="8rem" height="0.875rem" styleClass="bn-fs-skeleton__bone" />
          <div class="bn-fs-skeleton__actions">
            <p-skeleton width="7rem" height="2rem" borderRadius="0.375rem" styleClass="bn-fs-skeleton__bone" />
            <p-skeleton width="4.5rem" height="2rem" borderRadius="0.375rem" styleClass="bn-fs-skeleton__bone" />
          </div>
          <p-skeleton width="100%" height="0.875rem" styleClass="bn-fs-skeleton__bone" />
          <p-skeleton width="90%" height="0.875rem" styleClass="bn-fs-skeleton__bone" />
          <p-skeleton width="6rem" height="0.75rem" styleClass="bn-fs-skeleton__bone" />
          <p-skeleton width="5rem" height="1.75rem" styleClass="bn-fs-skeleton__bone" />
          <p-skeleton width="100%" height="0.55rem" borderRadius="999px" styleClass="bn-fs-skeleton__bone" />
        </div>
        <div class="bn-fs-skeleton__col">
          <div class="bn-fs-skeleton__mix-head">
            <p-skeleton width="7rem" height="0.875rem" styleClass="bn-fs-skeleton__bone" />
            <p-skeleton width="4rem" height="0.75rem" styleClass="bn-fs-skeleton__bone" />
          </div>
          @for (w of mixWidths; track w) {
            <div class="bn-fs-skeleton__mix-row">
              <p-skeleton [width]="w" height="0.75rem" styleClass="bn-fs-skeleton__bone" />
              <p-skeleton width="100%" height="0.4rem" borderRadius="999px" styleClass="bn-fs-skeleton__bone" />
            </div>
          }
        </div>
      </div>
    </div>
  `,
  styleUrl: './financial-snapshot-skeleton.component.scss',
})
export class FinancialSnapshotSkeletonComponent {
  /** Varied label widths so the mix list doesn't look identical. */
  readonly mixWidths = ['55%', '40%', '62%', '48%', '35%', '50%', '58%', '42%', '38%', '45%', '30%'];
}
